import React, { useState } from "react";
import NaviCustomTable from "../Components/Navi1CustomTable";
import "../Styling/Navi1LeadManagement.css";

const Navi1LeadsManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const columns = [
    {
      header: "Induction No.",
      accessor: "inductionNo",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Last Status",
      render: (row) => (
        <span className={`status ${row.status.toLowerCase()}`}>
          {row.status}
        </span>
      ),
    },
    {
      header: "Reason",
      accessor: "reason",
    },
    {
      header: "Follow Up Action",
      render: (row) => (
        <button className="action-btn">
          {row.status === "Pending" ? "Re-Engage" : "Contact"}
        </button>
      ),
    },
  ];

  const data = [
    {
      inductionNo: "IND1103",
      name: "Rahul Sharma",
      status: "Interested",
      reason: "Salary Expectation",
    },
    {
      inductionNo: "IND1158",
      name: "Shiv Yadav",
      status: "Pending",
      reason: "Technical Skill Gap",
    },
    {
      inductionNo: "IND1183",
      name: "Preeti Singh",
      status: "Declined",
      reason: "------",
    },
  ];

  const filteredData = data.filter(
    (row) =>
      row.inductionNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="Navi1-leads-page">

      {/* Card Container */}
      <div className="leads-card">
        <div className="card-header">
          Leads Management
        </div>

        <div className="card-body">

          <input
            type="text"
            placeholder="Search by Name and Induction No."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <NaviCustomTable
            columns={columns}
            data={filteredData}
            containerClass="leads-table-wrapper"
            boxShadow={false}
          />

        </div>
      </div>
    </div>
  );
};

export default Navi1LeadsManagement;